import React from "react";

import { StudentCountsInShapeColorByEnum } from "@/providers/store/api/shapes/enums/student-counts-in-shape.enum";

import { type IStudentClusterPayload } from "../../map-panel-context";

import StudentBy from "./student-by";
import { StudentClusterSummary } from "./student-cluster-summary";

interface StudentClusterPanelContentProps {
  payload: IStudentClusterPayload | null;
}

const StudentClusterPanelContentComponent: React.FC<StudentClusterPanelContentProps> =
  React.memo(({ payload }) => {
    return (
      <div className="space-y-6 px-3 py-4">
        <StudentClusterSummary studentsCount={payload?.studentsCount ?? 0} />
        <StudentBy
          data={payload?.dataBy ?? []}
          type={payload?.colorBy ?? StudentCountsInShapeColorByEnum.NONE}
        />
      </div>
    );
  });

export default StudentClusterPanelContentComponent;
